export default {"src":"/_next/static/media/moz-logo-white-rgb.2232bde4.svg","height":235,"width":984,"blurWidth":0,"blurHeight":0};